import React from 'react';
import { ASSETS } from '../assetManifest.js';
import { CONSTANTS } from '../data.js';
import { calculateStats } from '../gameLogic/dragonLogic.js';
import { getRarityColor, getElementColor, getElementGlow } from '../utils/gameUtils.js';
import { getAssetKey } from '../utils/assetUtils.js';

const BattlePreparationScreen = ({
  playerDragons,
  selectedBattleTeam,
  onSelectBattleDragon,
  onStartBattle,
  onCancelBattlePrep,
  selectedCompetitor,
}) => {
  const isTeamFull = selectedBattleTeam.length === 6;

  return (
    <div className="h-full flex flex-col">
      <div className="flex items-center justify-between mb-4 flex-shrink-0">
        <div className="flex flex-col">
          <h2 className="text-2xl font-mono font-semibold text-red-400 text-glow">Prepare for Battle</h2>
          <p className="text-sm text-gray-400">Select 6 dragons for your team to fight against {selectedCompetitor.name}.</p>
        </div>
        <div className="flex items-center space-x-4">
          <div className="font-mono text-lg">
            Selected: <span className={isTeamFull ? 'text-green-400' : 'text-yellow-400'}>{selectedBattleTeam.length}</span> / 6
          </div>
          <button onClick={onCancelBattlePrep} className="btn btn-secondary">Cancel</button>
          <button onClick={onStartBattle} disabled={!isTeamFull} className="btn btn-danger">Start Battle</button>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto custom-scrollbar pr-2 -mr-2">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
          {playerDragons.map(dragon => {
            const dragonData = CONSTANTS.DRAGONS[dragon.name];
            const calculatedStats = calculateStats(dragon);
            const isSelected = selectedBattleTeam.includes(dragon.id);

            return (
              <div
                key={dragon.id}
                className={`bg-gray-900/50 p-3 rounded-lg cursor-pointer transition-all duration-300 border-2 ${
                  isSelected ? 'border-red-500' : 'border-transparent hover:border-white/20'
                }`}
                onClick={() => onSelectBattleDragon(dragon.id)}
              >
                <div className="flex items-center mb-2">
                  <div className="relative mr-3">
                    <img
                      src={ASSETS.dragons[getAssetKey(dragon.name)].path}
                      alt={dragon.name}
                      className="w-12 h-12"
                      style={{ filter: `drop-shadow(0 0 4px ${getElementGlow(dragonData.element)})` }}
                    />
                    <div className="absolute -top-1 -right-1 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold text-black"
                        style={{ backgroundColor: getRarityColor(dragonData.rarity) }}>
                      {dragon.level}
                    </div>
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-mono font-bold">{dragon.name}</p>
                    <p className="text-xs font-sans" style={{ color: getRarityColor(dragonData.rarity) }}>
                      {dragonData.rarity}
                    </p>
                  </div>
                </div>
                <div className="grid grid-cols-3 gap-x-2 gap-y-1 text-xs mt-2 text-gray-400 border-t border-white/10 pt-2 font-sans">
                  <span title="Attack">ATK: {calculatedStats.attack}</span>
                  <span title="Speed">SPD: {calculatedStats.speed}</span>
                  <span title="Defense">DEF: {calculatedStats.defense}</span>
                  <span title="Strength">STR: {calculatedStats.strength}</span>
                  <span title="Physique">PHY: {calculatedStats.physique}</span>
                  <span title="Hidden Power">HPW: {calculatedStats.hiddenPower}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BattlePreparationScreen;
